<template>
  <div>
  <section class="hero-single-place">
    <div class="hero-container">
      <div class="row">
        <div class="col-lg-8">
          <img class="img-fluid place-img" src="../assets/shalbon-bihar.jpg"  alt="">
        </div>
      </div>
    </div>
  </section>

  <section class="single-place-desc">
    <div class="single-place-container">
      <div class="row">
        <div class="place-info col-12">
          <h4 class="place-name">শালবন বৌদ্ধ বিহার</h4>
          <div class="location">
            <b-icon-geo-alt></b-icon-geo-alt>
            <span>কোটবাড়ি</span>
          </div>
          <p class="description black-clr-txt">
            শালবন বৌদ্ধ বিহার বাংলাদেশের প্রাচীন সভ্যতার নিদর্শনগুলোর মধ্যে অন্যতম। কুমিল্লা জেলার লালমাই-ময়নামতি প্রত্নস্থলের অসংখ্য প্রাচীন স্থাপনাগুলোর একটি এই বৌদ্ধ বিহার । কুমিল্লার ময়নামতিতে খননকৃত সব প্রত্নতাত্ত্বিক নিদর্শনের মধ্যে শালবন বিহার অন্যতম প্রধান। কোটবাড়িতে বার্ডের কাছে লালমাই পাহাড়ের মাঝামাঝি এলাকায় এ বিহারটির অবস্থান। বিহারটির আশপাশে এক সময় শাল-গজারির ঘন বন ছিল বলে এ বিহারটির নামকরণ হয়েছিল শালবন বিহার।[তথ্যসূত্র প্রয়োজন] এর সন্নিহিত গ্রামটির নাম শালবনপুর। এখনো ছোট একটি বন আছে সেখানে। এ বিহারটি পাহাড়পুর বৌদ্ধ বিহারের মতো হলেও আকারে ছোট।
          </p>
          <h5 class="what-see-heading">এই ট্যুরে যা যা দেখবেন:</h5>
          <p class="what-see black-clr-txt">
            ১৮৭৫ সালের শেষ দিকে বর্তমান কোটবাড়ি এলাকায় একটি সড়ক তৈরির সময় একটি ইমারতের ধ্বংশাবশেষ উন্মোচিত হয়ে পড়ে। সে সময় আবিষ্কৃত ধ্বংসাবশেষকে একটি দুর্গ বলে অনুমান করা হয়েছিল। প্রত্নতাত্তিকদের মত অনুযায়ী এটি ছিল জয়কর্মান্তবসাক নামক একটি প্রাচীন নগরীর ধ্বংসাবশেষ। 
            আকারে চৌকো শালবন বিহারের প্রতিটি বাহু ১৬৭.৭ মিটার দীর্ঘ। বিহারের চার দিকের দেয়াল পাঁচ মিটার পুরু। কক্ষগুলো বিহারের চার দিকের বেষ্টনী দেয়াল পিঠ করে নির্মিত। বিহারে ঢোকা বা বের হওয়ার মাত্র একটাই পথ ছিল। এ পথ বা দরজাটি উত্তর ব্লকের ঠিক মাঝামাঝি স্থানে রয়েছে। প্রতিটি কক্ষের মাঝে ১.৫ মিটার চওড়া দেয়াল রয়েছে। বিহার অঙ্গনের ঠিক মাঝে ছিল কেন্দ্রীয় মন্দির। বিহারে সর্বমোট ১৫৫টি কক্ষ আছে। কক্ষের সামনে ৮.৫ ফুট চওড়া টানা বারান্দা ও তার শেষ প্রান্তে অনুচ্চ দেয়াল। প্রতিটি কক্ষের দেয়ালে তিনটি করে কুলুঙ্গি রয়েছে যেখানে অতীতে প্রতিমা বা তেলের প্রদীপ ইত্যাদি রাখা হতো। অন্যদিকে চার দিকের দেয়াল ও সামনে চারটি বিশাল গোলাকার স্তম্ভের ওপর নির্মিত হলঘরটি ভিক্ষুদের খাবার ঘর ছিল বলে ধারণা করা হয়। হলঘরের মাপ ১০ মিটার বাই ২০ মিটার। হলঘরের চার দিকে ইটের চওড়া রাস্তা রয়েছে। নানা সময়ে প্রত্নতাত্ত্বিক খননের মাধ্যমে বিহারটির ধ্বংসাবশেষ থেকে আটটি তাম্রলিপি, প্রায় ৪০০টি স্বর্ণ ও রৌপ্য মুদ্রা, অসংখ্য পোড়া মাটির ফলক বা টেরাকোটা, সিলমোহর, ব্রৌঞ্জ ও মাটির মূর্তি পাওয়া গেছে। 
            এ বিহার থেকে সংগৃহীত বিপুল পরিমাণ প্রত্নসম্পদ ময়নামতি জাদুঘরে প্রদর্শিত হচ্ছে।
          </p>
          <h5 class="how-goto-heading">যেভাবে যাবেন:</h5>
          <p class="how-goto black-clr-txt">
            কুমিল্লার টমছমব্রিজ হতে অথবা কোটবাড়ী বিশ্বরোড থেকে কোটবাড়ী সিএনজি স্ট্যান্ড যেতে হবে সিএনজি দিয়ে।  সেখান থেকে অটোতে ১০ টাকা জনপ্রতি ভাড়া দিয়ে চলে যেতে হবে সরাসরি শালবন বিহারের সামনে। আর শালবন বৌদ্ধ বিহারে প্রবেশে দেশি পর্যটক ২০ টাকা করে জনপ্রতি দিতে হবে।
          </p>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.hero-single-place {
  margin: 4rem 0 2rem;
}
.hero-single-place .hero-container {
  width: 70%;
  margin: 0 auto;
}
.hero-single-place .place-img {
  border-radius: 8px;
}
.single-place-desc {
  margin-bottom: 2rem;
}
.single-place-desc .single-place-container {
  width: 70%;
  margin: 0 auto;
}
.single-place-desc .place-name {
  font-weight: 600;
}
.single-place-desc .location {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 5px;
}
.b-icon.bi {
  margin-right: 2px;
}
.single-place-desc .what-see-heading, 
.single-place-desc .how-goto-heading {
  margin-top: 2rem;
  font-weight: 600;
}
.single-place-desc .black-clr-txt {
  color: #505050;
  line-height: 30px;
}
@media (max-width: 767px) {
  .hero-single-place .hero-container,
  .single-place-desc .single-place-container {
    width: 90%;
  }
}
</style>